import { render } from "./Escalas.vue?vue&type=template&id=d71d621a&scoped=true"
import script from "./Escalas.vue?vue&type=script&lang=js"
export * from "./Escalas.vue?vue&type=script&lang=js"

import "./Escalas.vue?vue&type=style&index=0&id=d71d621a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71d621a"]])

export default __exports__